
import {merge as observableMerge,  Observable } from "rxjs";

import { AfterContentInit, Component, ContentChildren, Input, QueryList } from "@angular/core";
import { take } from "rxjs/operators";
import { CommonFieldManagerDirective } from "../field-manager.directive";
import { ToggleFieldComponent } from "./field-toggle.component";
import { ToggleControlComponent } from "./toggle-control.component";

@Component({
    selector: "common-field-toggle-group",
    template: "<ng-content></ng-content>",
})
export class ToggleFieldGroupComponent implements AfterContentInit {
    @Input() public toggleFieldProps: string[];

    @ContentChildren(ToggleControlComponent, { descendants: true })
    public toggleControls: QueryList<ToggleControlComponent>;

    @ContentChildren(ToggleFieldComponent, { descendants: true })
    public toggleFields: QueryList<ToggleFieldComponent>;

    @ContentChildren(CommonFieldManagerDirective, { descendants: true })
    public fields: QueryList<CommonFieldManagerDirective>;

    public toggleFieldGroupTouched$: Observable<any>;

    public ngAfterContentInit(): void {
        this.toggleFieldGroupTouched$ = observableMerge(
            ...this.toggleControls.map((toggleControl) => toggleControl.toggleTouched$),
            ...this.toggleFields.map((toggleField) => toggleField.fieldTouched$),
        ).pipe(take(1));
    }
}
